const { Enums } = require("../enums");
const { ModelValidationException } = require("../exceptions/modelValidationException");

/**
 * @typedef {import("../types.d").Channel} Channel
 */

/**
 * Validates the channel data.
 * @param {Channel} channelData - The channel data to validate.
 * @param {boolean} throwError - Should this throw an error if validation fails?
 * @throws {ModelValidationException} If the channel data is invalid.
 */
function validateChannel(channelData, throwError = true) {
    const validationErrors = [];
    if (!channelData.name) {
        // t("Name is required")
        validationErrors.push({ fields: ["name"], message: "Name is required" });
    }
    if (!channelData.slug) {
        // t("Slug is required")
        validationErrors.push({ fields: ["slug"], message: "Slug is required" });
    } else if (!channelData.slug.match(/^[a-z0-9-]+$/)) {
        validationErrors.push({
            fields: ["slug"],
            // t("Slug must only contain lowercase letters, numbers, and hyphens")
            message: "Slug must only contain lowercase letters, numbers, and hyphens",
        });
    }
    if (!channelData.type) {
        // t("Type is required")
        validationErrors.push({ fields: ["type"], message: "Type is required" });
    }
    if (Enums.ChannelType[channelData.type] === undefined) {
        // t("Type must be one of CREATOR, SYSTEM, STAFF")
        validationErrors.push({ fields: ["type"], message: `Type must be one of CREATOR, SYSTEM, STAFF` });
    }
    if (validationErrors.length > 0) {
        if (!throwError) {
            return validationErrors;
        }
        // t("Invalid channel data")
        throw new ModelValidationException("Invalid channel data", validationErrors);
    }
    return false;
}

module.exports = { validateChannel };
